"use strict";

async function getData(url = '') {
    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer'
    });
    return response.text();
}

async function postData(url = '', data = {}) {
    const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: new URLSearchParams(data)
    });
    return response.text();
}

const utils = ($dispatch) => {
    const getTheme = () => {
        if (window.localStorage.getItem('theme')) {
            return window.localStorage.getItem('theme');
        }
        return 'light';
    };
    const setTheme = (value) => {
        window.localStorage.setItem('theme', value);
    };
    const getHeader = () => {
        if (window.localStorage.getItem('header-expanded')) {
            return JSON.parse(window.localStorage.getItem('header-expanded'));
        }
        return true;
    };
    const getSidebar = () => {
        if (window.localStorage.getItem('sidebar-expanded')) {
            return JSON.parse(window.localStorage.getItem('sidebar-expanded'));
        }
        return true;
    };
    return {
        loading: true,
        isDark: false,
        headerExpanded: true,
        sidebarExpanded: true,
        sidebarOpen: false,
        loaded() {
            this.isDark = this.currentTheme === 'dark' || this.currentTheme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches;
            this.loading = false;
            this.headerExpanded = getHeader();
            this.sidebarExpanded = getSidebar();
            this.$refs.loading.classList.add('hidden');
        },
        currentTheme: getTheme(),
        setLightTheme() {
            this.currentTheme = 'light';
            this.isDark = false;
            setTheme(this.currentTheme);
        },
        setDarkTheme() {
            this.currentTheme = 'dark';
            this.isDark = true;
            setTheme(this.currentTheme);
        },
        setSystemTheme() {
            this.currentTheme = 'system';
            this.isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            setTheme(this.currentTheme);
        },
        setHeader(value) {
            this.headerExpanded = value;
            window.localStorage.setItem('header-expanded', value);
        },
        setSidebar(value) {
            this.sidebarExpanded = value;
            window.localStorage.setItem('sidebar-expanded', value);
        },
        watchScreen() {
            if (window.innerWidth <= 1024) {
                this.isSidebarOpen = false;
                this.isSectionOpen = false;
            } else if (window.innerWidth >= 1024 && window.innerWidth <= 1280) {
                this.isSidebarOpen = true;
                this.isSectionOpen = false;
            } else if (window.innerWidth >= 1280) {
                this.isSidebarOpen = true;
                this.isSectionOpen = true;
            }
        },
        watchScreenNew() {
            if (window.innerWidth <= 1280) {
                this.isSidebarOpenNew = false;
                this.isSectionOpenNew = false;
            } else if (window.innerWidth >= 1280 && window.innerWidth <= 1536) {
                this.isSidebarOpenNew = true;
                this.isSectionOpenNew = false;
            } else if (window.innerWidth >= 1536) {
                this.isSidebarOpenNew = true;
                this.isSectionOpenNew = true;
            }
        },
        isShowingSpinner: false,
        showSpinner() {
            this.isShowingSpinner = true;
        },
        hideSpinner() {
            this.isShowingSpinner = false;
        },
        isUserMenuOpen: false,
        openUserMenu() {
            this.isUserMenuOpen = true;
            this.$nextTick(() => {
                this.$refs.UserMenu.focus();
            });
        },
        isSidebarOpen: window.innerWidth >= 1024 ? true : false,
        isSidebarShowing: (this.isSidebarOpen && window.innerWidth <= 1024) ? true : false,
        isSidebarOpenNew: window.innerWidth >= 1280 ? true : false,
        isSidebarShowingNew: (this.isSidebarOpen && window.innerWidth <= 1280) ? true : false,
        openSidebar() {
            this.isSidebarOpen = true;
            this.isSidebarShowing = true;
            this.isSidebarOpenNew = true;
            this.isSidebarShowingNew = true;
            this.$nextTick(() => {
                this.$refs.sidebar.focus();
            })
        },
        closeSidebar() {
            this.isSidebarOpen = false;
            this.isSidebarShowing = false;
            this.isSidebarOpenNew = false;
            this.isSidebarShowingNew = false;
        },
        escapeSidebar() {
            if (this.isSidebarShowing) {
                this.isSidebarOpen = false;
                this.isSidebarShowing = false;
            }
            if (this.isSidebarShowingNew) {
                this.isSidebarOpenNew = false;
                this.isSidebarShowingNew = false;
            }
        },
        isSectionOpen: window.innerWidth >= 1280 ? true : false,
        isSectionShowing: (this.isSectionOpen && window.innerWidth <= 1280) ? true : false,
        isSectionOpenNew: window.innerWidth >= 1536 ? true : false,
        isSectionShowingNew: (this.isSectionOpen && window.innerWidth <= 1536) ? true : false,
        openSection() {
            this.isSectionOpen = true;
            this.isSectionShowing = true;
            this.isSectionOpenNew = true;
            this.isSectionShowingNew = true;
            this.$nextTick(() => {
                this.$refs.section.focus();
            })
        },
        closeSection() {
            this.isSectionOpen = false;
            this.isSectionShowing = false;
            this.isSectionOpenNew = false;
            this.isSectionShowingNew = false;
        },
        escapeSection() {
            if (this.isSectionShowing) {
                this.isSectionOpen = false;
                this.isSectionShowing = false;
            }
            if (this.isSectionShowingNew) {
                this.isSectionOpenNew = false;
                this.isSectionShowingNew = false;
            }
        },
        isCMPanelOpen: false,
        openCMPanel() {
            this.isCMPanelOpen = true;
            this.$nextTick(() => {
                this.$refs.cmPanel.focus();
            })
        },
        isUserPanelOpen: false,
        openUserPanel() {
            this.isUserPanelOpen = true;
            this.$nextTick(() => {
                this.$refs.userPanel.focus();
            })
        },
        slidePanelContent: '',
        isSlidePanelOpen: false,
        openSlidePanel() {
            this.isSlidePanelOpen = true;
            this.$nextTick(() => {
                this.$refs.slidePanel.focus();
            })
        },
        closeSlidePanel() {
            this.isSlidePanelOpen = false;
        },
        modalPanelContent: '',
        isModalPanelOpen: false,
        openModalPanel() {
            this.isModalPanelOpen = true
            this.$nextTick(() => {
                this.$refs.modalPanel.focus()
            })
        },
        closeModalPanel() {
            this.isModalPanelOpen = false;
        },
        isSkeletonShowing: false,
        showSkeleton() {
            this.isSkeletonShowing = true;
        },
        hideSkeleton() {
            this.isSkeletonShowing = false;
        },
        scrollContent: '',
        resetPage() {
            window.location = window.location.href;
        },
        goToPage(url) {
            window.location = url;
        },
        openPage(url) {
            window.open(url, '_blank');
        },
        navigateMessage(url, title, html) {
            Swal.fire({
                title: title,
                html: html,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: Drupal.t('Yes'),
                cancelButtonText: Drupal.t('No'),
                width: 600,
                heightAuto: false,
                padding: '2.5rem',
                customClass: {
                    confirmButton: 'btn btn-success rounded-md shadow-xs px-4 py-2 mr-2',
                    cancelButton: 'btn btn-danger rounded-md shadow-xs px-4 py-2 mr-2'
                },
                buttonsStyling: false,
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location = URL_BASE + url;
                }
            });
        },
        sendData(layer, data) {
            this.showSpinner();
            $('.'+layer).html('<div class="text-center w-full"><i class="fa-regular fa-spinner fa-spin"></i></div>');

            postData(URL, data)
                .then(result => {
                    this.hideSpinner();
                    $('#'+layer).html(result);
                    $(document).ready(function(){
                        Tooltips.init();
                    });
                })
                .catch((error) => {
                    this.hideSpinner();
                    console.error('Error:', error);
                });
        },
        sendDataReload(layer, data) {
            this.showSpinner();
            $('.'+layer).html('<div class="text-center w-full"><i class="fa-regular fa-spinner fa-spin"></i></div>');

            postData(URL, data)
                .then(result => {
                    this.hideSpinner();
                    $('#'+layer).html(result);
                    location.reload();
                })
                .catch((error) => {
                    this.hideSpinner();
                    console.error('Error:', error);
                });
        },
        sendDataToggle(layer, data) {
            this.showSpinner();
            $('.'+layer).html('<div class="text-center w-full"><i class="fa-regular fa-spinner fa-spin"></i></div>');

            postData(URL, data)
                .then(result => {
                    this.hideSpinner();
                    $('.'+layer).html(result);
                    $(document).ready(function(){
                        FlatPicker.init();
                        Tooltips.init();
                    });
                })
                .catch((error) => {
                    this.hideSpinner();
                    $('.'+layer).html('');
                    console.error('Error:', error);
                });
        },
        sendDataChainedToggle(layer, data, layer2, data2) {
            this.showSpinner();
            $('.'+layer).html('<div class="text-center w-full"><i class="fa-regular fa-spinner fa-spin"></i></div>');
            $('.'+layer2).html('<div class="text-center w-full"><i class="fa-regular fa-spinner fa-spin"></i></div>');

            postData(URL, data)
                .then(result => {
                    this.hideSpinner();
                    $('.'+layer).html(result);
                    postData(URL, data2)
                        .then(result2 => {
                            this.hideSpinner();
                            $('.'+layer2).html(result2);
                            $(document).ready(function(){
                                FlatPicker.init();
                                Tooltips.init();
                            });
                        })
                        .catch((error) => {
                            this.hideSpinner();
                            $('.'+layer2).html('');
                            console.error('Error:', error);
                        });
                })
                .catch((error) => {
                    this.hideSpinner();
                    console.error('Error:', error);
                });
        },
        sendDataChainedToggleMessage(title, html, layer, data, layer2, data2) {
            this.showSpinner();

            if( html.length > 0 ) {
                Swal.fire({
                    title: title,
                    html: html,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: Drupal.t('Yes'),
                    cancelButtonText: Drupal.t('No'),
                    width: 600,
                    heightAuto: false,
                    padding: '2.5rem',
                    customClass: {
                        confirmButton: 'btn btn-success rounded-md shadow-xs px-4 py-2 mr-2',
                        cancelButton: 'btn btn-danger rounded-md shadow-xs px-4 py-2 mr-2'
                    },
                    buttonsStyling: false,
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.'+layer).html('<div class="text-center w-full"><i class="fa-regular fa-spinner fa-spin"></i></div>');
                        $('.'+layer2).html('<div class="text-center w-full"><i class="fa-regular fa-spinner fa-spin"></i></div>');

                        postData(URL, data)
                            .then(result => {
                                this.hideSpinner();
                                $('.'+layer).html(result);
                                postData(URL, data2)
                                    .then(result2 => {
                                        this.hideSpinner();
                                        $('.'+layer2).html(result2);
                                        $(document).ready(function(){
                                            FlatPicker.init();
                                            Tooltips.init();
                                        });
                                    })
                                    .catch((error) => {
                                        this.hideSpinner();
                                        $('.'+layer2).html('');
                                        console.error('Error:', error);
                                    });
                            })
                            .catch((error) => {
                                this.hideSpinner();
                                console.error('Error:', error);
                            });
                    } else {
                        this.hideSpinner();
                    }
                });
            } else {
                $('.'+layer).html('<div class="text-center w-full"><i class="fa-regular fa-spinner fa-spin"></i></div>');
                $('.'+layer2).html('<div class="text-center w-full"><i class="fa-regular fa-spinner fa-spin"></i></div>');

                postData(URL, data)
                    .then(result => {
                        this.hideSpinner();
                        $('.'+layer).html(result);
                        postData(URL, data2)
                            .then(result2 => {
                                this.hideSpinner();
                                $('.'+layer2).html(result2);
                                $(document).ready(function(){
                                    FlatPicker.init();
                                    Tooltips.init();
                                });
                            })
                            .catch((error) => {
                                this.hideSpinner();
                                $('.'+layer2).html('');
                                console.error('Error:', error);
                            });
                    })
                    .catch((error) => {
                        this.hideSpinner();
                        console.error('Error:', error);
                    });
            }
        },
        cleanDataToggle(layer) {
            $('.'+layer).html('');
        },
        sendDataNotify(status, data) {
            this.showSpinner();

            postData(URL, data)
                .then(result => {
                    this.hideSpinner();
                    $dispatch('notify', { content: result, type: status } );
                })
                .catch((error) => {
                    this.hideSpinner();
                    console.error('Error:', error);
                });
        },
        sendNotify(status, result) {
            $dispatch('notify', { content: result, type: status } );
        },
        sendDataMessage(title, html, layer, data) {
            this.showSpinner();

            if( html.length > 0 ) {
                Swal.fire({
                    title: title,
                    html: html,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: Drupal.t('Yes'),
                    cancelButtonText: Drupal.t('No'),
                    width: 600,
                    heightAuto: false,
                    padding: '2.5rem',
                    customClass: {
                        confirmButton: 'btn btn-success rounded-md shadow-xs px-4 py-2 mr-2',
                        cancelButton: 'btn btn-danger rounded-md shadow-xs px-4 py-2 mr-2'
                    },
                    buttonsStyling: false,
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.'+layer).html('<div class="text-center w-full"><i class="fa-regular fa-spinner fa-spin"></i></div>');
                        postData(URL, data)
                            .then(result => {
                                this.hideSpinner();
                                $('.'+layer).html(result);
                                $(document).ready(function(){
                                    Tooltips.init();
                                });
                            })
                            .catch((error) => {
                                this.hideSpinner();
                                console.error('Error:', error);
                            });
                    } else {
                        this.hideSpinner();
                    }
                });
            } else {
                $('.'+layer).html('<div class="text-center w-full"><i class="fa-regular fa-spinner fa-spin"></i></div>');
                postData(URL, data)
                    .then(result => {
                        this.hideSpinner();
                        $('.'+layer).html(result);
                        $(document).ready(function(){
                            Tooltips.init();
                        });
                    })
                    .catch((error) => {
                        this.hideSpinner();
                        console.error('Error:', error);
                    });
            }
        },
        sendDataMessageReload(title, html, data) {
            this.showSpinner();

            if( html.length > 0 ) {
                Swal.fire({
                    title: title,
                    html: html,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: Drupal.t('Yes'),
                    cancelButtonText: Drupal.t('No'),
                    width: 600,
                    heightAuto: false,
                    padding: '2.5rem',
                    customClass: {
                        confirmButton: 'btn btn-success rounded-md shadow-xs px-4 py-2 mr-2',
                        cancelButton: 'btn btn-danger rounded-md shadow-xs px-4 py-2 mr-2'
                    },
                    buttonsStyling: false,
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        postData(URL, data)
                            .then(result => {
                                this.hideSpinner();
                                location.reload();
                            })
                            .catch((error) => {
                                this.hideSpinner();
                                console.error('Error:', error);
                            });
                    } else {
                        this.hideSpinner();
                    }
                });
            } else {
                postData(URL, data)
                    .then(result => {
                        this.hideSpinner();
                        location.reload();
                    })
                    .catch((error) => {
                        this.hideSpinner();
                        console.error('Error:', error);
                    });
            }
        },
        sendDataModal(data) {
            this.showSpinner();
            this.modalPanelContent = '';

            postData(URL, data)
                .then(result => {
                    this.hideSpinner();
                    this.modalPanelContent = result;
                    $(document).ready(function(){
                        Tooltips.init();
                    });
                    this.openModalPanel();
                })
                .catch((error) => {
                    this.hideSpinner();
                    console.error('Error:', error);
                });
        },
        sendDataModalInit(data, init) {
            this.showSpinner();
            this.modalPanelContent = '';

            postData(URL, data)
                .then(result => {
                    this.hideSpinner();
                    this.modalPanelContent = result;
                    $(document).ready(function(){
                        Tooltips.init();
                        if (init.datatable) {
                            TableDatatableModal.init();
                        }
                        if (init.select2) {
                            ComponentsSelect2.init();
                        }
                    });
                    this.openModalPanel();
                })
                .catch((error) => {
                    this.hideSpinner();
                    console.error('Error:', error);
                });
        },
        sendDataModalForm(data) {
            this.showSpinner();
            this.modalPanelContent = '';

            postData(URL, data)
                .then(result => {
                    this.hideSpinner();
                    this.modalPanelContent = result;
                    $(document).ready(function(){
                        if (typeof ComponentsSelect2TagsLocalJson === 'undefined') {
                            // Do nothing
                        } else {
                            ComponentsSelect2TagsLocalJson.init();
                        }
                        FlatPicker.init();
                        Tooltips.init();
                        if (typeof ClassicEditor === 'undefined') {
                            // Do nothing
                        } else {
                            if ($('#modal_description').length) {
                                ClassicEditor.create( document.querySelector('#modal_description' ), { toolbar: [ 'removeFormat', 'bold', 'italic', 'underline', '|', 'link', '|', 'bulletedList', 'numberedList', 'alignment', 'undo', 'redo' ] }).then( editor => { /*console.log( editor );*/ } ).catch( error => {console.log( error );} );
                            }
                        }
                    });
                    this.openModalPanel();
                })
                .catch((error) => {
                    this.hideSpinner();
                    console.error('Error:', error);
                });
        },
        sendDataModalFormChained(data, layer2, data2) {
            this.showSpinner();
            this.modalPanelContent = '<div class="text-center w-full"><i class="fa-regular fa-spinner fa-spin"></i></div>';
            $('.'+layer2).html('<div class="text-center w-full"><i class="fa-regular fa-spinner fa-spin"></i></div>');

            postData(URL, data)
                .then(result => {
                    postData(URL, data2)
                        .then(result2 => {
                            this.hideSpinner();
                            $('.'+layer2).html(result2);
                            $(document).ready(function(){
                                if (typeof ComponentsSelect2TagsLocalJson === 'undefined') {
                                    // Do nothing
                                } else {
                                    ComponentsSelect2TagsLocalJson.init();
                                }
                                FlatPicker.init();
                                Tooltips.init();
                                if (typeof ClassicEditor === 'undefined') {
                                    // Do nothing
                                } else {
                                    if ($('#modal_description').length) {
                                        ClassicEditor.create( document.querySelector('#modal_description' ), { toolbar: [ 'removeFormat', 'bold', 'italic', 'underline', '|', 'link', '|', 'bulletedList', 'numberedList', 'alignment', 'undo', 'redo' ] }).then( editor => { /*console.log( editor );*/ } ).catch( error => {console.log( error );} );
                                    }
                                }
                            });
                            this.modalPanelContent = result;
                        })
                        .catch((error) => {
                            this.hideSpinner();
                            $('.'+layer2).html('');
                            console.error('Error:', error);
                        });
                })
                .catch((error) => {
                    this.hideSpinner();
                    console.error('Error:', error);
                });
        },
        sendDataSlide(data) {
            this.showSpinner();
            this.closeSlidePanel();
            this.slidePanelContent = '';

            postData(URL, data)
                .then(result => {
                    this.hideSpinner();
                    this.slidePanelContent = result;
                    $(document).ready(function(){
                        Tooltips.init();
                    });
                    this.openSlidePanel();
                })
                .catch((error) => {
                    this.hideSpinner();
                    console.error('Error:', error);
                });
        },
        saveDataSlide(layer, data) {
            this.showSpinner();
            this.closeSlidePanel();

            postData(URL, data)
                .then(result => {
                    this.hideSpinner();
                    if (layer) {
                        $('#'+layer).html(result);
                    }
                    $(document).ready(function(){
                        Tooltips.init();
                    });
                })
                .catch((error) => {
                    this.hideSpinner();
                    console.error('Error:', error);
                });
        },
        infiniteScroll(url) {
            this.showSpinner();
            this.showSkeleton();

            getData(url + '&' + $('#form_search').serialize())
                .then(result => {
                    this.hideSpinner();
                    this.hideSkeleton();
                    var jscroll = document.getElementsByClassName('jscroll-next')[0];
                    jscroll.outerHTML = result;
                    $(document).ready(function(){
                        Tooltips.init();
                    });
                })
                .catch((error) => {
                    this.hideSpinner();
                    this.hideSkeleton();
                    console.error('Error:', error);
                });
        },
    }
}
window.utils = utils;

$(document).ready(function() {

    $('.page-connect-meet').on('submit', '.submit-hide', function(e) {
        e.stopPropagation();
        var $this = $(this);
        $this.attr("disabled", true);
        return true;
    });

    $('#page_chat_content').on('click', '.btn-message', function (event) {
        event.stopPropagation();
        var $this = $(this);
        var id_thread = $this.data("id_thread");
        var id_project = $this.data("id_project");
        var id_conference = $this.data("id_conference");
        var id_node = $this.data("id_node");
        var id = $this.data("id");
        var type = $this.data("type");
        var controller = $this.data("controller");
        var action = $this.data("action");
        var message = $("#message").val();
        $("#message").val('');

        if( message.length > 0 ) {
            $.ajax({
                url: URL,
                type:'POST',
                data: { upaction: 'async', controller: controller, action: action, id: id, message: message, type: type, id_thread: id_thread, id_project: id_project, id_conference: id_conference, id_node: id_node },
                beforeSend: function(){
                    $("#page-spinner-loading").show();
                },
                complete: function(){
                    $("#page-spinner-loading").hide();
                },
                success: function(data) {
                    if (data) {
                        var template = '<li class="bg-white px-4 py-6 shadow-sm sm:rounded-lg sm:px-6">'+data+'</li>';
                        $('.chat_messages_'+id_thread).prepend(template);
                    }
                },
                error: function(exception){
                    console.log('Exception:' + JSON.stringify(exception));
                }
            });
        }
    });

});